import { motion } from "framer-motion";
import { EASE } from "./Reveal";

export const Preloader = () => (
  <motion.div
    data-testid="preloader"
    className="fixed inset-0 z-[200] flex flex-col items-center justify-center bg-ivory"
    exit={{ y: "-100%" }}
    transition={{ duration: 1.1, ease: EASE }}
  >
    <motion.img
      src="/assets/logo-green.png"
      alt="SORA events house"
      initial={{ clipPath: "inset(0 100% 0 0)", opacity: 0.3, filter: "blur(5px)" }}
      animate={{ clipPath: "inset(0 0% 0 0)", opacity: 1, filter: "blur(0px)" }}
      transition={{ duration: 1.6, ease: "easeInOut" }}
      className="w-52 select-none sm:w-64"
    />
    <motion.span
      className="absolute bottom-12 h-px bg-olive/40"
      initial={{ width: 0 }}
      animate={{ width: 120 }}
      transition={{ duration: 2.3, ease: "easeInOut" }}
    />
  </motion.div>
);
